/* eslint-disable import/no-unused-modules */ export var MOBILE_THRESHOLD = 750;
export var AboveLaptop = "@media screen and (min-width: 1440px)";
export var BelowMobile = "@media screen and (max-width: ".concat(750, "px)");
export var AboveMobile = "@media screen and (min-width: ".concat(750, "px)");
export var BelowContainer = "@media screen and (max-width: 1200px)";
export var BelowContainerWithPadding = "@media screen and (max-width: 1320px)";
